const backAlert = (callbackFn, from) => {
	window.history.replaceState(
		{
			goback: true
		},
		'',
		''
	);
	window.history.pushState(
		{
			goback: true
		},
		'',
		''
	);
	window.onpopstate = e => {
		if (e.state.goback) {
			window.clickLog &&
				window.clickLog('from=jianli_post_tstc_full' + from);
			callbackFn();
		}
	};
};

export default backAlert;



// WEBPACK FOOTER //
// ./src/module/basic/util/backAlert.js